import FeeRuleReport from './fee_rule_report.vue';

export default FeeRuleReport;
